import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import { shallowEqualImmutable } from 'react-immutable-render-mixin';
import { COLUMN_SETTINGS, FAVORITE_PROPERTIES } from 'customer-data-objects/property/PropertyListTypes';
import PreviewColumn from 'crm_components/dialog/propertyListEditor/PreviewColumn';
import SearchResultsCategories from 'crm_components/dialog/propertyListEditor/SearchResultsCategories';
import DnDColumnManagement from 'crm_components/dialog/propertyListEditor/DnDColumnManagement';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import PermissionTooltip from 'customer-data-objects-ui-components/permissions/PermissionTooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { ScrollingColumns } from 'foundations-components/transitional/components/ScrollingColumns';
import { ObjectTypesToIds } from 'customer-data-objects/constants/ObjectTypeIds';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import ObjectTypesType from 'customer-data-objects-ui-components/propTypes/ObjectTypesType';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import PortalIdParser from 'PortalIdParser';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class PropertyListEditor extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      search: ''
    };
    this.getCreatePropertyURI = () => {
      const {
        type
      } = this.props;
      if (!type) {
        return null;
      }
      const allObjectTypeIds = Object.values(ObjectTypesToIds);
      const objectTypeId = allObjectTypeIds.includes(type) ? type : ObjectTypesToIds[type];
      if (objectTypeId) {
        return `/property-settings/${PortalIdParser.get()}/${objectTypeId}/`;
      }
      return null;
    };
    this.handleSearchChange = ({
      target: {
        value
      }
    }) => {
      return this.setState({
        search: value
      });
    };
    this.renderSelectedPropertiesHeader = () => {
      return /*#__PURE__*/_jsx(Text, {
        as: "h6",
        paddingBlockEnd: "500",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `crm_components.PropertyListEditor.selected.${this.props.use}`,
          options: {
            count: this.props.value.length
          }
        })
      });
    };
    this.renderPreview = () => {
      if (!this.props.value) {
        return null;
      }
      const {
        type,
        use,
        value,
        onRequiredChange: handleRequiredChange,
        onAddOption: handleAddOption,
        onRemoveOption: handleRemoveOption,
        onReorderOption: handleReorderOption,
        onReset: handleReset,
        onSave: handleSave
      } = this.props;
      return /*#__PURE__*/_jsx(PreviewColumn, {
        rows: value
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        ,
        onRequiredChange: handleRequiredChange,
        onAddOption: handleAddOption,
        onRemoveOption: handleRemoveOption,
        onReorderOption: handleReorderOption,
        onReset: handleReset,
        onSave: handleSave,
        requirable: false,
        type: type,
        use: use
      });
    };
    this.renderCreateLink = () => {
      const {
        isCreateDisabled,
        isCreateMessageHidden
      } = this.props;
      if (isCreateMessageHidden) {
        return null;
      }
      const propertyURI = this.getCreatePropertyURI();
      if (!propertyURI) {
        return null;
      }
      return /*#__PURE__*/_jsxs(View, {
        paddingBlockStart: "500",
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "crm_components.GenericModal.createPropertyText"
        }), /*#__PURE__*/_jsx(PermissionTooltip, {
          disabled: !isCreateDisabled,
          tooltipKey: "editPropertiesDisabled",
          children: /*#__PURE__*/_jsx(Button, {
            href: isCreateDisabled ? '' : propertyURI,
            target: "_blank",
            use: "link",
            role: "link",
            disabled: isCreateDisabled,
            paddingInline: "0",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "crm_components.GenericModal.addPropertyLink"
            })
          })
        })]
      });
    };
    this.renderSearchResults = () => {
      const {
        value
      } = this.props;
      if (!value) {
        return null;
      }
      const {
        propertyCategories,
        type,
        use,
        onAddOption: handleAddOption,
        onRemoveOption: handleRemoveOption,
        onReset: handleReset,
        onSave: handleSave
      } = this.props;
      const {
        search
      } = this.state;
      return /*#__PURE__*/_jsx(SearchResultsCategories, {
        onAddOption: handleAddOption,
        onRemoveOption: handleRemoveOption,
        onReset: handleReset,
        onSave: handleSave,
        optionGroups: propertyCategories,
        selectedOptions: value,
        type: type || '',
        use: use,
        search: search
      });
    };
    this.renderSearchInput = () => {
      return /*#__PURE__*/_jsx(View, {
        paddingBlockEnd: "500",
        children: /*#__PURE__*/_jsx(SearchInput, {
          autoFocus: true,
          "data-test-id": "edit-columns-search",
          "data-selenium-test": "edit-columns-search",
          onChange: this.handleSearchChange,
          placeholder: I18n.text('crm_components.GenericModal.searchPropertiesPlaceholder'),
          value: this.state.search
        })
      });
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    return !shallowEqualImmutable(this.props, nextProps) || !shallowEqualImmutable(this.state, nextState);
  }
  render() {
    return /*#__PURE__*/_jsx(ScrollingColumns, {
      "data-selenium-test": "property-list-editor",
      leftColumnHeader: this.renderSearchInput(),
      leftColumnContent: this.renderSearchResults(),
      leftColumnFooter: this.renderCreateLink(),
      rightColumnHeader: this.renderSelectedPropertiesHeader(),
      rightColumnContent: this.renderPreview(),
      marginInlineStart: "-500",
      rightColumnWidth: "50%",
      maxHeight: "400px"
    });
  }
}
PropertyListEditor.displayName = 'PropertyListEditor';
PropertyListEditor.propTypes = {
  propertyCategories: PropTypes.array.isRequired,
  type: PropTypes.oneOfType([ObjectTypesType, ObjectTypeIdType]),
  use: PropTypes.oneOf([COLUMN_SETTINGS, FAVORITE_PROPERTIES]).isRequired,
  value: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  isCreateDisabled: PropTypes.bool,
  onAddOption: PropTypes.func,
  onRemoveOption: PropTypes.func,
  onReorderOption: PropTypes.func,
  onReset: PropTypes.func,
  onSave: PropTypes.func,
  onRequiredChange: PropTypes.func,
  isCreateMessageHidden: PropTypes.bool
};
PropertyListEditor.defaultProps = {
  isCreateDisabled: true
};
export default DnDColumnManagement(PropertyListEditor);